import Markdown from 'markdown-to-jsx';
import styled, { css } from 'styled-components';

export const ReportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;
export const ReportHeader = styled.h4`
  ${({ theme: { color, font } }) => css`
    color: ${color.midnight5};
    ${font.label}
  `};
`;
export const ReportBody = styled.div`
  ${({ theme: { color, fontSize, font } }) => css`
    color: ${color.midnight10};
    ${font.body};
    line-height: ${fontSize.xl};
  `};
`;
export const ReportSection = styled.div`
  white-space: pre-line;
`;
export const ProgressBarWrapper = styled.div`
  max-width: 200px;
  margin-bottom: 0.5rem;
`;
export const ReportAIPill = styled.div`
  ${({ theme: { color, font, fontSize, borderRadius } }) => css`
    margin-left: auto;
    border-radius: ${borderRadius.sm};
    background-color: ${color.turquoise20};
    color: ${color.midnight};
    padding: 0.1rem 0.5rem;
    line-height: ${fontSize.xl};
    ${font.body};
  `};
`;

export const MarkdownResponse = styled(Markdown)`
  ${({ theme: { fontWeight, font, color, spacing } }) => css`
    hr {
      margin: ${spacing.md};
      height: 1px;
      border: none;
      background-color: ${color.lightGrey};
    }
    strong {
      font-weight: ${fontWeight.bold};
    }
    em {
      font-style: italic;
    }
    h1 {
      ${font.h1}
    }
    h2 {
      ${font.h2}
    }
    p {
      ${font.body}
    }
    blockquote {
      border-left: 4px solid ${color.turquoise};
      padding: ${spacing.sm} ${spacing.md};
      background-color: ${color.turquoise20};
    }
  `}
`;
